<template>
  <v-dialog v-model="dialog" persistent max-width="500">
    <v-card>
      <v-card-title>แบบฟอร์มขอแต่งตั้ง</v-card-title>
      <v-subheader>วันที่ได้รับแต่งตั้ง</v-subheader>
      <v-card-text>
        <v-date-picker locale="th" class="elevation-1 mb-5" v-model="form.approved_date" full-width></v-date-picker>
      </v-card-text>
      <v-subheader>วันที่นำเสนอสภามหาวิทยาลัย</v-subheader>
      <v-card-text>
        <v-date-picker locale="th" class="elevation-1 mb-5" v-model="form.present_date" full-width></v-date-picker>
        <v-text-field outlined dense v-model="form.present_time" label="การประชุมครั้งที่/ปี"></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn color="success" @click="submit">บันทึก</v-btn>
        <v-btn color="error" @click="close_dialog">ปิด</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: [
    'dialog',
    'form'
  ],
  methods: {
    submit() {
      this.$emit('submit', this.form);
    },
    close_dialog() {
      this.$emit('update:dialog', false);
    }
  }
}
</script>